import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import Store from "../../Redux/store";
import helpers from "../../UtilitiesFunctions";
import { withLaunchSearch } from "../../utilities/appSessionKey";

/**
 * Shown when the user is authenticated but has no UMS profile for this app.
 * Logout clears the session and returns to the login screen.
 */
function AccessDenied({ onLogout }) {
  const history = useHistory();

  const handleLogout = () => {
    if (typeof onLogout === "function") {
      onLogout();
      return;
    }
    helpers.clearData();
    Store.dispatch({ type: "USER_LOGOUT" });
    Store.dispatch({ type: "AUTHZ_CLEAR" });
    history.push(withLaunchSearch("/"));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        px: 3,
        textAlign: "center",
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        Access denied
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420, mb: 3 }}>
        Your account has no UMS profile for this application. Contact an
        administrator if you need access.
      </Typography>
      <Button variant="contained" color="primary" onClick={handleLogout}>
        Logout
      </Button>
    </Box>
  );
}

export default AccessDenied;
